import { RmsAccountOccupationSelect } from '@/ui/features/badging/badging-customizations/badge-create/RmsAccountOccupationSelect';
import { RmsAccountSelection } from '@/ui/features/badging/badging-customizations/badge-create/types';
import { AccountSelection } from '@juvare/badging/ui/features/badge-management/components/BadgeAccountsSelectionPanel/types';
import { Column, TextCell } from '@juvare/common-data-table-ui/DataTable';
import { TFunction } from 'i18next';
import React from 'react';

export const extendAccountSelectionSelectedColumns = (
    setAccounts: React.Dispatch<React.SetStateAction<AccountSelection[]>>,
    t: TFunction<'rms'>,
) => {
    const handleAccountOccupationChanged = (occupationId: string | undefined, accountToChange: RmsAccountSelection) => {
        setAccounts((prevAccounts) =>
            prevAccounts.map((a) =>
                a.id === accountToChange.id
                    ? {
                          ...accountToChange,
                          options: { ...accountToChange.options, occupationId },
                      }
                    : a,
            ),
        );
    };

    return (columnsDefault: Column<AccountSelection>[]): Column<AccountSelection>[] => {
        return [
            ...columnsDefault.slice(0, -1),
            {
                headerLabel: t('credentialing.occupation'),
                cellFunction: (row) => {
                    const docRow = row as RmsAccountSelection;

                    return (
                        <TextCell>
                            <RmsAccountOccupationSelect
                                sx={{ width: { xs: 200, md: 75, lg: 140, xl: 200 } }}
                                accountSelection={docRow}
                                onOptionsPartialChange={(optionsChange) => {
                                    handleAccountOccupationChanged(optionsChange.occupationId, docRow);
                                }}
                                hideDropdownWhenNoOptions={true}
                                hideDropdownWhenOneOption={true}
                            />
                        </TextCell>
                    );
                },
            },
            ...columnsDefault.slice(-1),
        ];
    };
};
